module.exports = __webpack_public_path__ + "static/media/image-7.6a935fe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-54/image-7.jpg
// module id = 269
// module chunks = 0